import type { SecondaryBarType } from "app/reducers/_reducers/SecondaryBarReducer";

export const PACKAGE_NAME = "digitalsuite" as const;
export const SECONDARY_BAR_TYPE = "Activation" as SecondaryBarType;
export const CONFIG_ID = "Activation";
